// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"e6eb95c3","232":"77f1787d","313":"a4e53a74","475":"e505865f","956":"bfdfab1c"}[chunkId] + ".chunk.js";
};